<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/price-region" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreatePriceRegion") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RegionCode')"
              >
                <vs-input
                  :label="$t('setup.label.RegionCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.regionCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RegionName')"
              >
                <vs-input
                  :label="$t('setup.label.RegionName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.regionName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Country")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Country')"
                >
                  <v-select
                    label="countryName"
                    :options="template.countryData"
                    v-model="countryName"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.id"
                    @input="getStates"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.States")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.States')"
                >
                  <v-select
                    label="stateName"
                    multiple
                    :options="State.statesData"
                    v-model="teamData.states"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createTeamData"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";

const teamEmptyObj = {
  locale: "en",
  regionCode: "",
  regionName: "",
  countryId: "",
  stateName: "",
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      teamData: teamEmptyObj,
      data: {},
      userIds: [],
      userNames: [],
      countryName: "",
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      createEntityResp: (state) => state.priceRegion.createpriceRegion,
      template: (state) => state.priceRegion.RegionsTemplateList,
      State: (state) => state.priceRegion.GetState,
    }),
  },
  methods: {
    async createTeamData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let indx = this.userNames.indexOf(this.countryName);
      this.teamData.countryId = this.userIds[indx];

      try {
        let test = [];
        for (let temp of this.teamData.states) {
          test.push(temp.id);
        }
        this.teamData.states = test;
        this.teamData.countryId = this.countryName;

        await this.$store.dispatch(
          "priceRegion/createpriceRegionAction",
          this.teamData
        );
        if (this.createEntityResp) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Price Region Created Successfully!",
            type: "success",
          });
          this.$router.push(`/setup/price-region`);
          this.resetForm();
        }
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getRegionsTemplate() {
      try {
        await this.$store.dispatch("priceRegion/setRegionsTemplate");

        this.userNames = [];
        this.userIds = [];
        for (let tempUser of this.template.countryData) {
          this.userNames.push(tempUser.countryName);
          this.userIds.push(tempUser.id);
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getStates() {
      try {
        await this.$store.dispatch("priceRegion/getStatesAction", {
          id: this.countryName,
          data: { countryId: this.countryName },
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    resetForm() {
      this.teamData = {};
      this.countryName = "";
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
    cancel() {
      this.$router.push("/setup/price-region");
    },
  },
  watch: {},
  mounted() {
    this.resetForm();
    this.getRegionsTemplate();
  },
};
</script>
